import { Pipe, PipeTransform } from '@angular/core';
import { MenuItemCatalogGroupModel } from '../models/menu-item-catalog-group.model';
import { MenuItemCatalogModel } from '../models/menu-item-catalog.model';

@Pipe({
  name: 'imageFinder'
})
export class ImageFinderPipe implements PipeTransform {

  constructor() { }

  transform(item: MenuItemCatalogModel | MenuItemCatalogGroupModel): string {
    try {
      if (item.images && item.images.length > 0 && item.images[0].url) {
        return `${item.images[0].url}?${new Date().getTime()}`;
      } else {
        return '';
      }
    } catch {
      return '';
    }
  }

}
